module.exports = __webpack_public_path__ + "static/autofill-cart-617b666c204232345027cc4f9d9e9751.png";